<template>
  <snackbar-queue :items="items" @remove="removeItem"/>
</template>
<script>
import SnackbarQueue from "~/views/layouts/components/SnackbarQueue";
export default {
  components: {SnackbarQueue},
  data: () => ({
    items: []
  }),
  methods: {
    /**
     * @param id
     */
    removeItem(id) {
      const self = this;
      const index = self.items.findIndex(item => item.id === id);

      if (index !== -1) {
        self.items.splice(index, 1);
      }
    },

    /**
     * @param prefix
     * @returns {string}
     */
    uniqueId: prefix =>
        `${prefix}_` +
        Math.random()
            .toString(36)
            .substr(2, 9),

    /**
     * @param {string} text
     */
    warning(text) {
      let self = this;
      this.items.push({
        id: self.uniqueId("item_"),
        message: this.$t(`api['${text}']`),
        color: 'warning',
      });
    },

    /**
     * @param {string} text
     */
    error(text) {
      let self = this;
      this.items.push({
        id: self.uniqueId("item_"),
        message: this.$t(`api['${text}']`),
        color: 'error',
      });
      console.log(this.items);
    },

    /**
     * @param {string} text
     */
    success(text) {
      let self = this;
      this.items.push({
        id: self.uniqueId("item_"),
        message: this.$t(`api['${text}']`),
        color: 'success',
      });
    },

    /**
     * @param {string} text
     */
    info(text) {
      let self = this;
      this.items.push({
        id: self.uniqueId("item_"),
        message: this.$t(`api['${text}']`),
        color: 'info',
      });
    },
  }
}
</script>